var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2339 8.49484C16.2339 12.782 12.7585 16.2573 8.47142 16.2573C4.1843 16.2573 0.708907 12.782 0.708907 8.49484C0.708907 4.20773 4.1843 0.732344 8.47142 0.732344C12.7585 0.732344 16.2339 4.20773 16.2339 8.49484Z",
    fill: "#D8BE8D",
    fillOpacity: 0.19,
    stroke: "#D8BE8D",
    strokeWidth: 1.035
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36621 8.23703L7.43621 10.307L11.0587 6.42578",
    stroke: "white",
    strokeWidth: 1.5525,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.77689abb4761839f9b907c4e19cd72a6.svg";
export { ForwardRef as ReactComponent };